import {
  AppBar,
  Box,
  Container,
  Grid,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import InvirteLogoComponent from "./InvirteLogo";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Stack
      component="footer"
      sx={{ backgroundColor: "primary.main", color: "white", py: 4, px: 3 }}
    >
      <Grid container columns={4} spacing={{ xs: 6, md: 1 }}>
        <Grid
          item
          xs={4}
          md={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            sx={{ display: "flex", alignItems: "center" }}
            component={Link}
            to={"/"}
            href={"/"}
          >
            <InvirteLogoComponent direction="column" />
          </Box>
        </Grid>
        <Grid item xs={4} md={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography fontSize="large" mb={2} color="text.footerColor">
              Contenido
            </Typography>
            <Stack spacing={2} textAlign={{ xs: "center", md: "left" }}>
              <Link href="/" to={"/"} style={{ fontFamily: "Inter" }}>
                Inicio
              </Link>
              <Link to="/projects" style={{ fontFamily: "Inter" }}>
                Proyectos
              </Link>
              {/* <Link to="/property" style={{ fontFamily: "Inter" }}>
                Inmuebles
              </Link> */}
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={4} md={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography mb={2} color="text.footerColor">
              ¿Necesitas ayuda?
            </Typography>
            <Stack spacing={2}>
              <Typography fontWeight="normal">
                Teléfono: +34-91-799-4700
              </Typography>
              <Typography fontWeight="normal">
                Correo: ejemplo@gmail.com
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={4} md={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography mb={2} color="text.footerColor">
              Dirección
            </Typography>
            <Typography component="span" fontSize="normal" fontWeight="normal">
              123 Main St, Anytown USA 12345
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default Footer;
